'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { Checkbox } from 'ui/components/Checkbox/Checkbox';
import { useTranslation } from '@whoop/i18n/lang/client';

export default function MakeThisAGiftCheckbox({
  asAGift,
  toggleAsAGift,
}: {
  asAGift: boolean;
  toggleAsAGift: () => void;
}): JSX.Element {
  const [checked, setChecked] = useState<boolean | 'indeterminate'>(asAGift);
  const { t } = useTranslation('cart');

  const handleToggle = (): void => {
    const newValue = checked === 'indeterminate' ? false : !checked;
    setChecked(newValue);
    toggleAsAGift();
  };

  return (
    <div
      aria-label={t('toggleGiftStatus')}
      className='w-full cursor-pointer space-y-4 rounded-2xl bg-white'
      onClick={handleToggle}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleToggle();
        }
      }}
      role='button'
      tabIndex={0}
    >
      <div className='flex justify-start p-4'>
        <Image
          alt='Gift'
          height={24}
          role='presentation'
          src='/gift.svg'
          width={24}
        />
        <p className='w-auto whitespace-nowrap pl-2 font-bold'>
          {t('makeThisAGift')}
        </p>
        <div className='flex w-full justify-end'>
          <Checkbox
            checked={checked}
            data-testid='make-this-a-gift-checkbox'
            variant='normal'
          />
        </div>
      </div>
    </div>
  );
}
